module.exports = __webpack_public_path__ + "img/bone_marrow.8821a817.png";